import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntBasicHB } from "../../../../../models/handBooks/basicHB";
import {
  useAddIndustryTypeMutation,
  useDeleteIndustryTypeMutation,
  useEditIndustryTypeMutation
} from "../../../../../redux/api/handBooksApi/organic/industryTypeApi";

const useIndustryType = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addIndustryType] = useAddIndustryTypeMutation();
  const [deleteIndustryType] = useDeleteIndustryTypeMutation();
  const [editIndustryType] = useEditIndustryTypeMutation();

  async function onAddIndustryType(newIndustryType: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addIndustryType(newIndustryType).then((response: any) => {
		if (response.error !== undefined) {

		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteIndustryType(industryType: EntBasicHB) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteIndustryType(industryType.id).then((response: any) => {
			if (response.error !== undefined && response.error.status === 400) {
			  status = false;
			  throw new Error(response.error.data.message);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({ title: t('msg.successDelete') });
			  if (refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };

  async function onEditIndustryType(editedIndustryType: EntBasicHB): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editIndustryType(editedIndustryType).then((response: any) => {
		if (response.error !== undefined && response.error.status === 400) {
		  throw new Error(response.error.data.message);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({ title: t('msg.successEdited') });
		  if (refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };
  return { onAddIndustryType, onDeleteIndustryType, onEditIndustryType }

}
export { useIndustryType };

